import React from 'react';

export default {
  routes: [{
      exact: true,
      path: '/',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "home",webpackPrefetch: true */ '@/pages/Home'),
      ),
    },
    {
      exact: true,
      path: '/o2n',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/o2n'),
      ),
    },
    {
      exact: true,
      path: '/redirect',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Redirect'),
      ),
    },
    {
      exact: true,
      path: '/authorization',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Authorization'),
      ),
    },
    {
      exact: true,
      path: '/env',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Env'),
      ),
    },
    {
      exact: true,
      path: '/debug',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Debug'),
      ),
    },
    //  商品详情页
    {
      exact: true,
      path: '/skuInfo/:skuId/:salesNumber',
      isDynamic: true,
      ID: 'pay001',
      component: React.lazy(
        () => import( /* webpackChunkName: "sku",webpackPrefetch: true */ '@/pages/order/SkuInfoExpired'),
      ),
    },
    {
      exact: true,
      path: '/sku/:skuId/:salesNumber',
      isDynamic: true,
      ID: 'pay001',
      component: React.lazy(
          () => import( /* webpackChunkName: "sku",webpackPrefetch: true */ '@/pages/order/SkuInfo'),
      ),
    },
    {
      exact: true,
      path: '/i/:number',
      isDynamic: true,
      ID: 'pay001',
      component: React.lazy(
          () => import( /* webpackChunkName: "invite",webpackPrefetch: true */ '@/pages/order/sku-detail'),
      ),
    },
    //  新商品详情页
    {
      exact: true,
      path: '/sku-detail',
      isDynamic: true,
      ID: 'pay001',
      component: React.lazy(
          () => import( /* webpackChunkName: "skuDetail",webpackPrefetch: true */ '@/pages/order/sku-detail'),
      ),
    },
    //  策略商品详情页
    {
      exact: true,
      path: '/strategyInfo/:linkNumber',
      isDynamic: true,
      ID: 'pay006',
      component: React.lazy(
          () => import( /* webpackChunkName: "sku",webpackPrefetch: true */ '@/pages/order/StrategyInfo'),
      ),
    },

    {
      exact: true,
      path: '/strategy-info-jcj/:linkNumber',
      isDynamic: true,
      ID: 'pay006',
      component: React.lazy(
          () => import( /* webpackChunkName: "sku",webpackPrefetch: true */ '@/pages/order/Strategy-info-jcj'),
      ),
    },

    {
      //策略无权限页
      exact: true,
      path: '/strategy/noPermission',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "skuInfoPre",webpackPrefetch: true */ '@/pages/order/strategyError'),
      ),
    },
    {
      //后台预览页
      exact: true,
      path: '/skuInfoPre',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "skuInfoPre",webpackPrefetch: true */ '@/pages/order/SkuInfo'),
      ),
    },
    //  确认订单页
    {
      exact: true,
      path: '/orderConfirm/:skuId/:salesNumber',
      isDynamic: true,
      title:"确认订单",
      ID: 'pay002',
      component: React.lazy(
        () => import( /* webpackChunkName: "orderConfirm",webpackPrefetch: true */ '@/pages/order/OrderConfirm'),
      ),
    },

    {
      exact: true,
      path: '/strategyOrderConfirm/:skuId/:salesNumber/:linkNumber',
      isDynamic: true,
      ID:'pay007',
      component: React.lazy(
          () => import( /* webpackChunkName: "orderConfirm",webpackPrefetch: true */ '@/pages/order/StrategyOrderConfirm'),
      ),
    },

    {
      exact: true,
      path: '/strategyList/:salesNumber',
      isDynamic: true,
      ID:'pay005',
      component: React.lazy(
          () => import( /* webpackChunkName: "orderConfirm",webpackPrefetch: true */ '@/pages/order/StrategyList'),
      ),
    },
    //  支付页
    {
      exact: true,
      path: '/orderPay/:orderNumber/:salesNumber',
      isDynamic: true,
      title:"订单支付",
      ID: 'pay003',
      component: React.lazy(
        () => import( /* webpackChunkName: "orderPay",webpackPrefetch: true */ '@/pages/order/OrderPay'),
      ),
    },
    {
      exact: true,
      path: '/alreadyPayInfo/:orderNumber',
      isDynamic: true,
      title:"订单支付",
      component: React.lazy(
        () => import( /* webpackChunkName: "alreadyPayInfo",webpackPrefetch: true */ '@/pages/order/AlreadyPayInfo'),
      ),
    },
    {
      exact: true,
      path: '/order/other-pay/:orderNumber',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "alreadyPayInfo",webpackPrefetch: true */ '@/pages/order/OtherPay'),
      ),
    },
    {
      exact: true,
      path: '/order/BulkPay/:orderNumber/:subOrderNumber',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "alreadyPayInfo",webpackPrefetch: true */ '@/pages/order/BulkPay'),
      ),
    },
    {
      exact: true,
      path: '/order/unionPayResult',
      isDynamic: true,
      title:"支付提示",
      component: React.lazy(
          () => import( /* webpackChunkName: "alreadyPayInfo",webpackPrefetch: true */ '@/pages/order/UnionPayResult'),
      ),
    },
    //  支付成功页
    {
      exact: true,
      path: '/payResult',
      title:"提示",
      isDynamic: true,
      ID: 'pay004',
      component: React.lazy(
        () => import( /* webpackChunkName: "payResult",webpackPrefetch: true */ '@/pages/order/PayResult'),
      ),
    },
    {
      exact: true,
      path: '/openBrowser',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "openBrowser",webpackPrefetch: true */ '@/pages/order/OpenBrowser'),
      ),
    },
    {
      exact: true,
      path: '/BrowserInWechat',
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/BrowserInWechat'),
      ),
    },
    {
      exact: true,
      path: '/WeChatPc',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/WeChatPc'),
      ),
    },
    {
      exact: true,
      path: '/transitionPage',
      title:"提示",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/TransitionPage'),
      ),
    },
    {
      exact: true,
      path: '/staticTransitionPage/:showType',
      title:"提示",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/TransitionPage/StaticTransitionPage'),
      ),
    },
    {
      exact: true,
      path: '/delayCoupon/:id/:salesNumber',
      title:"服务延期",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/coupon/delayCoupon'),
      ),
    },
    {
      exact: true,
      path: '/changeCoupon/:id/:salesNumber',
      title:"服务变更申请",
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/coupon/changeCoupon'),
      ),
    },
    {
      exact: true,
      path: '/delayCoupon/error',
      title:"服务延期",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/coupon/error'),
      ),
    },
    {
      exact: true,
      path: '/delayCoupon/transitionPage',
      title:"提示",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/coupon/TransitionPage'),
      ),
    },
    {
      exact: true,
      path: '/sign/sign-start',
      title:"服务延期",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/sign/sign-start'),
      ),
    },
    {
      exact: true,
      path: '/sign/sign-success/:applyId',
      title:"服务延期",
      isDynamic: true,
      component: React.lazy(
        () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/sign/sign-success'),
      ),
    },
    {
      exact:true,
      path:'/order/MyRefund',
      title:'我的退款',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund')
      ),
    },
    {
      exact:true,
      path:'/order/sub-order-refund/:orderNumber',
      title:'我的退款',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund/SubOrderRefund')
      ),
    },
    {
      exact:true,
      path:'/order/bank-info/:orderNumber',
      title:'银行卡信息',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/BankInfo')
      ),
    },
    {
      exact:true,
      path:'/order/MyRefund/sign-start',
      title:'我的退款',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund/SignStart')
      ),
    },
    {
      exact:true,
      path:'/order/MyRefund/confirmation',
      title:'确认书',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund/Confirmation')
      ),
    },
    {
      exact:true,
      path:'/order/MyRefund/success',
      title:'提示',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund/Success')
      ),
    },
    {
      exact:true,
      path:'/paySuccess/:orderNumber/:salesNumber',
      title:'提示',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/paySuccess')
      ),
    },
    {
      exact:true,
      path:'/order/MyRefund/register',
      title:'提示',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/MyRefund/Register')
      ),
    },
    {
      exact:true,
      path:'/order/lakala-success',
      title:'拉卡拉支付成功页',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/lakala-success')
      ),
    },
    {
      exact:true,
      path:'/order/lianl-success',
      title:'连连支付成功页',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/lianl-success')
      ),
    },
    {
      exact:true,
      path:'/order-generation/:orderNumber',
      title:'订单生成页',
      ID:'pay102',
      isDynamic: true,
      component:React.lazy(
          ()=> import(/* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/order/order-generation')
      ),
    },
  ],
};
